import { render } from "./NutritionReminders.vue?vue&type=template&id=65267cf4&scoped=true"
import script from "./NutritionReminders.vue?vue&type=script&lang=js"
export * from "./NutritionReminders.vue?vue&type=script&lang=js"

import "./NutritionReminders.vue?vue&type=style&index=0&id=65267cf4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65267cf4"]])

export default __exports__